<div>

  <main #main [class.standalone]="toggle.standalone">

    <div>

      <nav class="lib-nav install sticky" [hidden]="!promptInstallPrompt">
        <!---->

        <lib-logo class="lib-elevation-1" variant="icon"></lib-logo>

        <span class="lib-spacer-fixed"></span>

        <h6 class="lib-legend">Pick up where you left off. Anytime.</h6>

        <span class="lib-spacer"></span>

        <span class="lib-spacer-fixed"></span>

        <lib-button theme="stroked" (click)="promptInstall($event)" pTrackEvent="click" pTrackAction="install"
          pTrackCategory="app">
          <span>Install</span>
        </lib-button>

        <span class="lib-spacer-fixed"></span>

        <button class="lib-button" (click)="dismissInstall($event)">
          <lib-icon name="close"></lib-icon>
        </button>

      </nav>

      <lib-cookie-consent class="sticky" [hidden]="!!toggle.hideExtras"></lib-cookie-consent>

      <router-outlet></router-outlet>

    </div>

  </main>

  <app-navigation></app-navigation>

  <aside [class.expand]="!!notifications?.length">
    <div *ngFor="let n of notifications; index as i; trackBy: trackById">
      <app-notification [notification]="n" (dismiss)="onNotificationDismiss($event)"></app-notification>
    </div>
  </aside>

  <div class="working"></div>

</div>

<ng-template #webViewTemplate>
  <div class="web-view" *ngIf="webView">
    <nav class="lib-nav">
      <h6>{{webView?.label}}</h6>
      <span class="lib-spacer"></span>
      <a class="lib-button-flat-dark" [href]="webView?.actionUrl">
        <span>{{webView?.action}}</span>
      </a>
    </nav>
    <iframe [src]="webView?.url | safe: 'resourceUrl'"></iframe>
  </div>
</ng-template>

<ng-template #addHomeTemplate>
  <app-add-home></app-add-home>
</ng-template>

<ng-template #offerAcceptedTemplate>
  <app-offer-accepted [selected]="offerAcceptedSelected"></app-offer-accepted>
</ng-template>

<!-- <ng-template #referToBrokerNowTemplate>
  <app-refer-now></app-refer-now>
</ng-template> -->

<ng-template #bookCallTemplate>
  <lib-book-a-call [organization]="organization" [room]="room" [user]="currentUser" (event)="bookCallEvent($event)">
  </lib-book-a-call>
</ng-template>

<ng-template #budgetNotificationModalTemplate>
  <div class="budget-notification">
    <nav class="lib-nav">
      <span class="lib-spacer"></span>
      <button class="lib-button close" (click)="closeBudgetNotification()">
        <lib-icon name="close"></lib-icon>
      </button>
    </nav>
    <div class="budget-notification-content">
      <h2>Your home buying budget may look a bit different…</h2>
      <p>We improved the accuracy of our affordability calculator so you can have a clearer picture of your budget.
        Think of it as upgrading to 4k resolution 😎. Now you can look for homes with even greater confidence.</p>
      <p>Got a question on your new budget and how our calculator works?</p>
    </div>
    <nav class="lib-nav">
      <lib-button theme="flat-primary" (buttonClick)="onBudgetNotificationCTAClick()">Chat to our team</lib-button>
      <span class="lib-spacer"></span>
      <lib-button theme="raised" (buttonClick)="onBudgetNotificationDismissClick()">Don't show this message again
      </lib-button>
    </nav>
  </div>
</ng-template>
